// @flow @jsx h
import { h } from 'preact'
import { Counter } from './Counter'
import { bem } from '../../lib/bem'
import styles from './InfoBox.css'

type Props = {
  showLink?: string,
  linkText?: string,
  href?: string,
  amount: number
}

export const InfoBox = ({ amount, showLink, href, linkText }: Props) => {
  const amountInBottles = Math.ceil(amount * 20).toLocaleString('no')
  const amountInFleece = Math.ceil(amount * 33).toLocaleString('no')

  return (
    <div class={styles['info-box']}>
      <div class={styles['info-box__inner']}>
        <span class='nrk-sr'>
          Mens du har lest denne artikkelen har det havnet{' '}
          {parseFloat(amount / 1000).toFixed(1)} tonn plast i havet. Det
          tilsvarer {amountInBottles} flasker eller {amountInFleece} bleier.
        </span>
        <p class={styles['info-box__paragraph']} aria-hidden>
          <span class={styles['info-box__text-line']}>
            Mens du har lest denne artikkelen
          </span>{' '}
          <span class={styles['info-box__text-line']}>har det havnet</span>
          <Counter
            amount={parseFloat(amount / 1000).toFixed(1)}
            afterText={' tonn'}
          />
          <span class={styles['info-box__big-text']}>plast i havet</span>
        </p>
        <p class={bem(styles['info-box__paragraph'], 'darker')} aria-hidden>
          <span class={styles['info-box__text-line']}>
            Det tilsvarer {amountInBottles} flasker{' '}
          </span>
          <span class={styles['info-box__text-line']}>
            eller {amountInFleece} bleier.
          </span>
        </p>
        {showLink &&
          href && (
            <a
              class={`nrk-button ${styles['info-box__link-button']}`}
              href={href}
            >
              {linkText || 'Hva kan jeg gjøre med det?'}
              <span aria-hidden>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 26 15'
                  width='25'
                >
                  <path
                    stroke='currentColor'
                    fill='none'
                    strokeLinecap='round'
                    d='M2 7.5h22m-6-6l6 6-6 6'
                  />
                </svg>
              </span>
            </a>
          )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/v1/components/InfoBox.js